import React from 'react';
import Dialog from '.';

/**
 * Form dialog that creates an activity: `Form` is rendered inside it, and the submitted values go
 * through `mapSubmit` before reaching `onSubmit`.
 */
const ActivityFormDialog = function ActivityFormDialog({
  id,
  title,
  Icon,
  Form,
  mapSubmit = (data) => data,
  open,
  onClose,
  onSubmit,
  fullScreen = false,
  isOperator,
  phoneNumber,
}) {
  return (
    <Dialog
      id={id}
      title={title}
      icon={<Icon />}
      open={open}
      onClose={onClose}
      onCancel={onClose}
      onSubmit={(data) => onSubmit(mapSubmit(data))}
      width="sm"
      fullWidth
      fullScreen={fullScreen}
      form
      dividers
    >
      <Form isOperator={isOperator} phoneNumber={phoneNumber} />
    </Dialog>
  );
};

export default ActivityFormDialog;
